import { render, staticRenderFns } from "./DataViewSidebarServices.vue?vue&type=template&id=1d5beba1&scoped=true"
import script from "./DataViewSidebarServices.vue?vue&type=script&lang=js"
export * from "./DataViewSidebarServices.vue?vue&type=script&lang=js"
import style0 from "./DataViewSidebarServices.vue?vue&type=style&index=0&id=1d5beba1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5beba1",
  null
  
)

export default component.exports